import {
  FETCH_MARKET_ORDERS,
  FETCH_MARKET_ORDER_DETAIL,
  CREATE_ORDER,
  FETCH_MARKET_ORDER_DUPLICATE,
  FETCH_BACK_ORDER_DETAIL,
  CLEAR_BACK_ORDER_DETAIL,
  CHANGE_ORDER_ITEM_BACK_ORDER,
  CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  marketOrdersList: {
    orders: [],
    hasMore: false,
    error: null,
    loading: false,
  },
  marketOrderDetail: {
    order: undefined,
    error: null,
    loading: false,
  },
  marketOrderDuplicate: {
    newOrderId: undefined,
    error: null,
    loading: false,
  },
  backOrderDetail: {
    orderId: undefined,
    detail: [],
    error: null,
    loading: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_MARKET_ORDERS
    // --------------------------------------------------------------------------
    case FETCH_MARKET_ORDERS.init:
      return {
        ...state,
        marketOrdersList: { ...state.marketOrdersList, hasMore: false, error: null, loading: true },
      };
    case FETCH_MARKET_ORDERS.success:
      return {
        ...state,
        marketOrdersList: {
          ...state.marketOrdersList,
          orders: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_MARKET_ORDERS.failure:
      return {
        ...state,
        marketOrdersList: {
          ...state.marketOrdersList,
          orders: [],
          pages: 1,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_MARKET_ORDER_DETAIL
    // --------------------------------------------------------------------------
    case FETCH_MARKET_ORDER_DETAIL.init:
      return {
        ...state,
        marketOrderDetail: { ...state.marketOrderDetail, error: null, loading: true },
      };
    case FETCH_MARKET_ORDER_DETAIL.success:
      return {
        ...state,
        marketOrderDetail: { ...state.marketOrderDetail, order: action.payload, error: null, loading: false },
      };
    case FETCH_MARKET_ORDER_DETAIL.failure:
      return {
        ...state,
        marketOrderDetail: {
          ...state.marketOrderDetail,
          order: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_ORDER
    // --------------------------------------------------------------------------
    case CREATE_ORDER.init:
      return {
        ...state,
        marketOrderDetail: { ...state.marketOrderDetail, error: null, loading: true },
      };
    case CREATE_ORDER.success:
      return {
        ...state,
        marketOrderDetail: { ...state.marketOrderDetail, order: action.payload, error: null, loading: false },
      };
    case CREATE_ORDER.failure:
      return {
        ...state,
        marketOrderDetail: {
          ...state.marketOrderDetail,
          order: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_MARKET_ORDER_DUPLICATE
    // --------------------------------------------------------------------------
    case FETCH_MARKET_ORDER_DUPLICATE.init:
      return {
        ...state,
        marketOrderDuplicate: { ...state.marketOrderDuplicate, error: null, loading: true },
      };
    case FETCH_MARKET_ORDER_DUPLICATE.success:
      return {
        ...state,
        marketOrderDuplicate: { ...state.marketOrderDuplicate, newOrderId: action.payload.new_order_id, error: null, loading: false },
      };
    case FETCH_MARKET_ORDER_DUPLICATE.failure:
      return {
        ...state,
        marketOrderDuplicate: {
          ...state.marketOrderDuplicate,
          newOrderId: false,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_BACK_ORDER_DETAIL
    // --------------------------------------------------------------------------
    case FETCH_BACK_ORDER_DETAIL.init:
      return {
        ...state,
        backOrderDetail: {
          orderId: action.orderId,
          detail: [],
          error: null,
          loading: true,
        },
      };
    case FETCH_BACK_ORDER_DETAIL.success:
      return {
        ...state,
        backOrderDetail: {
          ...state.backOrderDetail,
          detail: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_BACK_ORDER_DETAIL.failure:
      return {
        ...state,
        backOrderDetail: {
          ...state.backOrderDetail,
          detail: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CLEAR_BACK_ORDER_DETAIL
    // --------------------------------------------------------------------------
    case CLEAR_BACK_ORDER_DETAIL:
      return {
        ...state,
        backOrderDetail: {
          orderId: undefined,
          detail: [],
          error: null,
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CHANGE_ORDER_ITEM_BACK_ORDER
    // --------------------------------------------------------------------------
    case CHANGE_ORDER_ITEM_BACK_ORDER: {
      const { orderItemId, value } = action.payload;
      const updatedItems = state.marketOrderDetail.order.items.map((orderItem) => ({
        ...orderItem,
        in_back_order: orderItem.id === orderItemId ? value : orderItem.in_back_order,
      }));
      return {
        ...state,
        marketOrderDetail: {
          ...state.marketOrderDetail,
          order: {
            ...state.marketOrderDetail.order,
            items: updatedItems,
          },
        },
      };
    }
    // --------------------------------------------------------------------------
    // CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER
    // --------------------------------------------------------------------------
    case CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER: {
      const { orderItemId, value } = action.payload;
      const items = state.marketOrderDetail.order.items;
      const indexToChange = items.findIndex((elem) => elem.id === orderItemId);
      if (indexToChange > -1) {
        items[indexToChange].completed_not_back_order = value;
      }
      return {
        ...state,
        marketOrderDetail: {
          ...state.marketOrderDetail,
          order: {
            ...state.marketOrderDetail.order,
            items: items,
          },
        },
      };
    }
    default:
      return state;
  }
};
